module.exports = __webpack_public_path__ + "img/copy.e5206791.png";